//@ts-check
import React from 'react';
import Integration from './Integration';
import SynchronizationLog from './SynchronizationLog';

var CRMComponent = function CRMComponent(_ref) {
  var id = _ref.id,
      showLog = _ref.showLog;
  if (showLog) return React.createElement(SynchronizationLog, null);
  return React.createElement(Integration, {
    id: id
  });
};

CRMComponent.defaultProps = {
  showLog: false,
  id: 'Engage'
};
export default CRMComponent;